import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

// initialize database

const config = {
  apiKey: "AIzaSyALqtTXWSVJUtVI3x7smzoA6AuKYG9P5N8",
  authDomain: "superpajo-6cf88.firebaseapp.com",
  databaseURL: "https://superpajo-6cf88.firebaseio.com",
  projectId: "superpajo-6cf88",
  storageBucket: "superpajo-6cf88.appspot.com",
  messagingSenderId: "93920241804",
  appId: "1:93920241804:web:57ad810ef2c30baaa1f3a9",
};

const app = initializeApp(config);
const db = getDatabase(app);
const auth = getAuth(app);

export { app, db, auth };
